import { render, staticRenderFns } from "./message-content-contact-request.vue?vue&type=template&id=d55ca958&scoped=true&"
import script from "./message-content-contact-request.vue?vue&type=script&lang=js&"
export * from "./message-content-contact-request.vue?vue&type=script&lang=js&"
import style0 from "./message-content-contact-request.vue?vue&type=style&index=0&id=d55ca958&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55ca958",
  null
  
)

export default component.exports